import React from "react";
import { get } from "lodash";

import { Button } from "../../../components/Field";
import { showToast } from "../../../helpers/notify";
import AsyncGet from "../../../components/Materials/AsyncGet";
import style from "./style.module.css";

const ClearNotification = ({ toggleNotification }) => {
    return (
        <div className={style.clearAllWrappar}>
            <div className={style.clearAll}>
                <AsyncGet
                    url="/notification/delete-all"
                    method="delete"
                    loadOnMount={false}
                    permissionText="Notification Delete All"
                    onFetch={({ data }) => {
                        if (get(data, 'success', false) === true) {
                            showToast("All notifications have been cleared.");
                            toggleNotification();
                        }
                    }}
                    render={({ loadFromAPI }) => {
                        return (
                            <Button label="Clear All" onClick={loadFromAPI} size="tiny" />
                        )
                    }}
                />
            </div>
        </div>
    )
}

export default ClearNotification;